module.exports = __webpack_public_path__ + "static/opentable-guest-experience.1e784457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/opentable-guest-experience.jpg
// module id = ./src/pages/opentable-guest-experience.jpg
// module chunks = 199769300672215